'use client';

import { c as _c } from "react/compiler-runtime";
import { useState } from 'react';
import { CompareListColorPicker } from '@/app/lcv/components/sections/compare/list/header-cta/color-picker';
import { CompareListGallery } from '@/app/lcv/components/sections/compare/list/header-cta/gallery';
import { CompareListHeadline } from '@/app/lcv/components/sections/compare/list/header-cta/headline';
import { CompareListPriceCta } from '@/app/lcv/components/sections/compare/list/header-cta/price-cta';
import { RowWrapper } from '@/app/lcv/components/sections/compare/list/header-cta/row-wrapper';
import { PRODUCT_COMPARE_DATA_TEST } from '@/app/lcv/components/sections/compare/tracking';
import type { CompareListProps, LcvCompareModel } from '@/app/lcv/components/sections/compare/types';
import { getLcvCategoryFromLcvModel } from '@/app/lcv/components/sections/compare/utils';
import type { ColorListItem } from '@/app/lcv/components/shared/color-list/utils';
import { createDataAttributes } from '@/app/utils/createDataAttributes';
import { safeCall } from '@/app/utils/safeCall';
import type { LcvModelCategory, LcvModelColor } from '@/types/tis-cms/types';
export type CompareHeaderCtaItemType = {
  model: LcvCompareModel;
  category: LcvModelCategory;
  selectedColor?: LcvModelColor;
};
interface CompareHeaderCtaListProps extends CompareListProps {
  selectedColors: (LcvModelColor | undefined)[];
  onSelectColor?: (index: number, color: LcvModelColor) => void;
}
export const CompareHeaderCtaList = t0 => {
  const $ = _c(50);
  const {
    selectedColors: t1,
    values: t2,
    lineupModelsGroup,
    onSelectColor
  } = t0;
  let t3;
  if ($[0] !== t1) {
    t3 = t1 === undefined ? [] : t1;
    $[0] = t1;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const selectedColors = t3;
  let t4;
  if ($[2] !== t2) {
    t4 = t2 === undefined ? [] : t2;
    $[2] = t2;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const values = t4;
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = [false, false, false];
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  const [isInteriorViewByColumns, setIsInteriorViewByColumns] = useState(t5);
  let t6;
  if ($[5] !== onSelectColor) {
    t6 = (index, color) => {
      if (!color || !("color" in color)) {
        return;
      }
      safeCall(onSelectColor, index, color);
    };
    $[5] = onSelectColor;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  const handleOnSelectColor = t6;
  let t7;
  if ($[7] !== lineupModelsGroup || $[8] !== selectedColors || $[9] !== values) {
    let t8;
    if ($[11] !== lineupModelsGroup || $[12] !== selectedColors) {
      t8 = (value, columnIndex) => {
        const model = lineupModelsGroup[value];
        return <CompareListGallery key={columnIndex} model={model} columnIndex={columnIndex} selectedColor={selectedColors[columnIndex]} onSlideChange={slideIndex => setIsInteriorViewByColumns(prev => {
          const tmp = prev.slice();
          tmp[columnIndex] = slideIndex === 2;
          return tmp;
        })} />;
      };
      $[11] = lineupModelsGroup;
      $[12] = selectedColors;
      $[13] = t8;
    } else {
      t8 = $[13];
    }
    t7 = values.map(t8);
    $[7] = lineupModelsGroup;
    $[8] = selectedColors;
    $[9] = values;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[14] !== t7) {
    t8 = <RowWrapper className="mb-0">{t7}</RowWrapper>;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== lineupModelsGroup || $[17] !== values) {
    let t10;
    if ($[19] !== lineupModelsGroup) {
      t10 = (value_0, columnIndex_0) => {
        const model_0 = lineupModelsGroup[value_0];
        if (!model_0) {
          return <div key={columnIndex_0} className="relative w-full"><h2 className="text-body-1 font-noto-bold center-x absolute top-0 text-center text-gray-400" {...createDataAttributes({
              test: `${PRODUCT_COMPARE_DATA_TEST.headline}-${columnIndex_0}`
            })} role="cell">เลือกรุ่นรถ</h2></div>;
        }
        const category = getLcvCategoryFromLcvModel(model_0);
        if (!category) {
          return <div key={columnIndex_0} role="cell" />;
        }
        return <CompareListHeadline key={columnIndex_0} model={model_0} category={category} {...createDataAttributes({
          test: `${PRODUCT_COMPARE_DATA_TEST.headline}-${columnIndex_0}`
        })} />;
      };
      $[19] = lineupModelsGroup;
      $[20] = t10;
    } else {
      t10 = $[20];
    }
    t9 = values.map(t10);
    $[16] = lineupModelsGroup;
    $[17] = values;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[21] !== t9) {
    t10 = <RowWrapper className="relative">{t9}</RowWrapper>;
    $[21] = t9;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] !== handleOnSelectColor || $[24] !== isInteriorViewByColumns || $[25] !== lineupModelsGroup || $[26] !== selectedColors || $[27] !== values) {
    let t12;
    if ($[29] !== handleOnSelectColor || $[30] !== isInteriorViewByColumns || $[31] !== lineupModelsGroup || $[32] !== selectedColors) {
      t12 = (value_1, columnIndex_1) => {
        const model_1 = lineupModelsGroup[value_1];
        if (!model_1) {
          return <div key={columnIndex_1} role="cell" />;
        }
        const category_0 = getLcvCategoryFromLcvModel(model_1);
        if (!category_0) {
          return <div key={columnIndex_1} role="cell" />;
        }
        return <CompareListColorPicker key={columnIndex_1} model={model_1} category={category_0} selectedColor={selectedColors[columnIndex_1]} onSelectColor={color_0 => handleOnSelectColor(columnIndex_1, color_0)} isInteriorView={isInteriorViewByColumns[columnIndex_1]} {...createDataAttributes({
          test: `${PRODUCT_COMPARE_DATA_TEST.color}-${columnIndex_1}`
        })} />;
      };
      $[29] = handleOnSelectColor;
      $[30] = isInteriorViewByColumns;
      $[31] = lineupModelsGroup;
      $[32] = selectedColors;
      $[33] = t12;
    } else {
      t12 = $[33];
    }
    t11 = values.map(t12);
    $[23] = handleOnSelectColor;
    $[24] = isInteriorViewByColumns;
    $[25] = lineupModelsGroup;
    $[26] = selectedColors;
    $[27] = values;
    $[28] = t11;
  } else {
    t11 = $[28];
  }
  let t12;
  if ($[34] !== t11) {
    t12 = <RowWrapper>{t11}</RowWrapper>;
    $[34] = t11;
    $[35] = t12;
  } else {
    t12 = $[35];
  }
  let t13;
  if ($[36] !== lineupModelsGroup || $[37] !== selectedColors || $[38] !== values) {
    let t14;
    if ($[40] !== lineupModelsGroup || $[41] !== selectedColors) {
      t14 = (value_2, columnIndex_2) => {
        const model_2 = lineupModelsGroup[value_2];
        if (!model_2) {
          return <div key={columnIndex_2} role="cell" />;
        }
        const category_1 = getLcvCategoryFromLcvModel(model_2);
        if (!category_1) {
          return <div key={columnIndex_2} role="cell" />;
        }
        return <CompareListPriceCta key={columnIndex_2} model={model_2} category={category_1} selectedColor={selectedColors[columnIndex_2]} {...createDataAttributes({
          test: `${PRODUCT_COMPARE_DATA_TEST.priceCta}-${columnIndex_2}`
        })} />;
      };
      $[40] = lineupModelsGroup;
      $[41] = selectedColors;
      $[42] = t14;
    } else {
      t14 = $[42];
    }
    t13 = values.map(t14);
    $[36] = lineupModelsGroup;
    $[37] = selectedColors;
    $[38] = values;
    $[39] = t13;
  } else {
    t13 = $[39];
  }
  let t14;
  if ($[43] !== t13) {
    t14 = <RowWrapper>{t13}</RowWrapper>;
    $[43] = t13;
    $[44] = t14;
  } else {
    t14 = $[44];
  }
  let t15;
  if ($[45] !== t10 || $[46] !== t12 || $[47] !== t14 || $[48] !== t8) {
    t15 = <div role="rowgroup" className="min-h-120 space-y-4 pt-4 md:min-h-135">{t8}{t10}{t12}{t14}</div>;
    $[45] = t10;
    $[46] = t12;
    $[47] = t14;
    $[48] = t8;
    $[49] = t15;
  } else {
    t15 = $[49];
  }
  return t15;
};